<template>
  <div style="margin-top: 10px">
    <p class="goldenP">
      <img
        src="@/assets/globe1.png"
        style="
          width: 20px;
          margin-top: -4px;
          margin-left: 10px;
          margin-right: 5px;
        "
        alt=""
      />
      {{ $t("LanguageEn.txtTournament") }}
    </p>
  </div>
</template>

<script>
export default {
  name: "Countries",
  props: {
    text: String,
  },
};
</script>

<style scoped>
.goldenP {
  background: #2c2d31;
  height: 45px;
  color: #f0af49;
  font-weight: bold;
  padding-top: 5%;
  font-size: 14px;
  padding: 10px;
  margin-bottom: 0px;
}
</style>
